var carousel = {
    selector: '[data-carousel="element"]',
    init: function() {
        var self = this;
        var element = document.querySelector(self.selector);

		if (element === null) {
			return;
		}

        var prev = element.querySelector('[data-carousel="prev"]');
		var next = element.querySelector('[data-carousel="next"]');

		var sliderElement = element.querySelector('[data-carousel="slider"]');

        var slider = tns({
            container: sliderElement,
            controls: false,
			infinite: true,
			rewind: false,
			loop: true,
			nav: false,
			mouseDrag: true,
            edgePadding: 60,
            preventScrollOnTouch: 'auto',
            responsive: {
                520: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 4
                },
                1600: {
                    items: 6,
                    edgePadding: 100
                }
            }
        } );

        prev.addEventListener('click', () => {
			if ( true === this.progress ) {
				return;
			}

			this.progress = true;
			slider.goTo('prev');

			setTimeout( () => {
				this.progress = false;
			}, 600 );
		});

		next.addEventListener('click', () => {
			if ( true === this.progress ) {
				return;
			}

			this.progress = true;
			slider.goTo('next');

			setTimeout( () => {
				this.progress = false;
			}, 600 );
		});

		const options = { 
            threshold: 0.75,
            rootMargin: '0px'
        }
		
		var observer = new IntersectionObserver((entries, observer) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
                    setTimeout(() => {
                        slider.goTo('next');
                    }, 250);
					observer.unobserve( entry.target );
				}
			} );
		}, options);

		observer.observe(element);

        self.lightbox();
    },
    lightbox: function() {
        $( 'a[data-rel^=lightcase]' ).lightcase( {
            
            maxWidth: 2560,
            maxHeight: 1600,
            showSequenceInfo: false,
            overlayOpacity: 1,
            shrinkFactor: 0.9
        } );
    }
}

export { carousel };